import { cloneDeep } from 'lodash';


function getParticleSystems(chapter): string[] {
  if (chapter.customData === undefined) {
    return [];
  }
  if (chapter.customData.particleSystems === undefined) {
    return [];
  }
  return chapter.customData.particleSystems;
}


// there is already a chapter id. replace it
function buildParticleSystemId(chapterId, currentId) {
  const root = currentId.split('/').pop();
  return `${chapterId}/${root}`;
}

// build a look up table of new -> old particle system ids
function particleSystemNameLookup(_chapters) {
  return _chapters.reduce((acc, chapter) => {
    for (const name of getParticleSystems(chapter)) {
      const newName = buildParticleSystemId(chapter.id, name);
      acc[newName] = name;
    }
    return acc;
  }, {});
}


// assign updated particle names back to chapters
function setParticlesForChapter(_chapters) {
  return _chapters.map(chapter => {
    const particleSystems = getParticleSystems(chapter).map(
      name => buildParticleSystemId(chapter.id, name)
    );
    return {
      ...chapter,
      customData: {
        ...chapter.customData,
        particleSystems
      }
    };
  });
}


// given a lookup, and the original particle systems,
// clone and rename to match what is stated in each chapter

function cloneAndRenameNeededParticles(nameLookup, particleSystemRepo) {
  return Object.keys(nameLookup).reduce((acc, newName) => {
    const oldName = nameLookup[newName];
    const clone = cloneDeep(particleSystemRepo.find(particle => particle.id === oldName));
    clone.id = newName;
    acc.push(clone);
    return acc;
  }, []);
}


// when a bookmark is saved,
// all chapter ids change
// update particle system ids in chapter
// and update customData with new particleSystem ids
// return chapters and customData
// merging chapters and customData is only a concern of combineModules
export function updateParticleSystems(chapters, customDataParticleSystems) {
  const nameLookupForParticles = particleSystemNameLookup(chapters);
  const currentChaptersWithUpdatedParticles = setParticlesForChapter(chapters);
  const currentParticleSystemsRenamed = cloneAndRenameNeededParticles(
    nameLookupForParticles,
    customDataParticleSystems
  );

  return {
    particleSystemsForCustomData: currentParticleSystemsRenamed,
    chapters: currentChaptersWithUpdatedParticles
  };
}
